import { atom } from 'jotai'

const Plan = atom({
    default: 'monthly',
    key: 'plan'
});


export default Plan;
